"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBProductHeader;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _svbReactComponents = require("@svb/svb-react-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Portal components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This molecule renders an SVB Product Header as per design
 */

/**
 * SVBProductHeader
 * @param {props} - including options below
 *  {props} - Primary title
 *  {secondaryHeaderText}  - Secondary title which appears when the header bar is in collapsed state
 *  {description} = breif description
 *  {versionList} - list of version labels `|array of strings|`
 *  {versionValue} - selected version value from the list
 *  {handleVersionSelect} - on click of version list - refer SVBLabels React Component
 *  {labelText|labelType|subLabelType} = refer SVBLabels React component
 *  {buttonText} - text title for the button
 *  {handleButtonPress} - on click for the button
 *  {enableStickyBar} - Enable/disable collapsed(sticky bar) or expanded bar
 *  {maxWH} - add relative max width (100%-maxwh) for the sticky product header
 * @returns SVB Product header as per the design
 */
function SVBProductHeader(props) {
  const headerText = (props === null || props === void 0 ? void 0 : props.headerText) || "";
  // const secondaryHeaderText = props?.secondaryHeaderText || ""
  const description = (props === null || props === void 0 ? void 0 : props.description) || "";
  const versionList = (props === null || props === void 0 ? void 0 : props.versionList) || [];
  const versionValue = (props === null || props === void 0 ? void 0 : props.versionValue) || "";
  //  const handleVersionSelect = props?.handleVersionSelect
  const labelText = (props === null || props === void 0 ? void 0 : props.labelText) || "ACTIVE";
  const labelType = (props === null || props === void 0 ? void 0 : props.labelType) || "status-labels-large";
  const subLabelType = (props === null || props === void 0 ? void 0 : props.subLabelType) || "status-label-active";
  const button1Text = (props === null || props === void 0 ? void 0 : props.button1Text) || "OpenAPI Spec";
  const button2Text = (props === null || props === void 0 ? void 0 : props.button2Text) || "Postman Collection";
  const handleButton1Press = (props === null || props === void 0 ? void 0 : props.handleButton1Press) || false;
  const handleButton2Press = (props === null || props === void 0 ? void 0 : props.handleButton2Press) || false;
  const enableStickyBar = (props === null || props === void 0 ? void 0 : props.enableStickyBar) || false;
  const maxWH = (props === null || props === void 0 ? void 0 : props.maxWH) || '';
  const breadCrumbs = (props === null || props === void 0 ? void 0 : props.breadCrumbs) || false;
  const finalClass = props !== null && props !== void 0 && props.extraClasses ? (props === null || props === void 0 ? void 0 : props.extraClasses) + ' position-sticky svb-product-header-container col-md-12 px-3 pt-4 pb-3 svb-product-header-collapsed-index' : 'position-sticky svb-product-header-container col-md-12 px-3 pt-4 pb-3 svb-product-header-collapsed-index';
  const handleVersionSelect = (0, _react.useCallback)(e => {
    if (typeof props.handleVersionSelect === 'function') {
      props.handleVersionSelect(e);
    }
  });
  return enableStickyBar ? /*#__PURE__*/_react.default.createElement("div", {
    className: finalClass,
    style: {
      maxWidth: maxWH ? "calc(100% - ".concat(maxWH, "px)") : '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12 col-sm-12 col-lg-12 col-xl-3 col-xxl-5 align-items-center d-flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "collapsed-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sub-heading-large bold"
  }, headerText))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12 col-sm-12 col-lg-12 col-xl-9 col-xxl-7 d-flex flex-md-column flex-lg-row align-items-md-end justify-content-end small widgets-sticky"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "header-sticky mx-1 d-flex"
  }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBLabels, {
    extraClasses: "py-1 px-3 d-flex align-items-center sticky-mb",
    showCircle: true,
    labelType: labelType,
    labelText: labelText,
    subLabelType: subLabelType
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "pe-2"
  }), (versionList === null || versionList === void 0 ? void 0 : versionList.length) > 0 && /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBLabels, {
    extraClasses: "py-1 px-3",
    versionValues: versionList,
    onPress: event => handleVersionSelect(event),
    value: versionValue,
    labelType: "versioning-large"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "pe-2"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "d-flex"
  }, handleButton1Press && /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBButton, {
    onClick: handleButton1Press,
    extraClasses: "py-1 px-3 wSticky-btn-1",
    rightIconExtraClasses: "p-1 h-100",
    text: button1Text,
    size: "small",
    style: "secondary",
    state: "default",
    type: "text",
    icon: "download-blue.svg",
    iconSide: "right"
  }), handleButton2Press && /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBButton, {
    onClick: handleButton2Press,
    extraClasses: "ms-2 py-1 px-3 wSticky-btn-2",
    rightIconExtraClasses: "p-1 h-100",
    text: button2Text,
    size: "small",
    style: "secondary",
    state: "default",
    type: "text",
    icon: "download-blue.svg",
    iconSide: "right"
  }))))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "svb-product-header-container col-md-12 position-relative"
  }, breadCrumbs && /*#__PURE__*/_react.default.createElement("div", {
    className: "pt-4"
  }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBBreadCrumb, {
    breadCrumbs: breadCrumbs,
    extraClasses: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row pt-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-9 col-md-7 col-sm-9"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "heading-xlarge"
  }, headerText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-3 col-md-5 d-flex  flex-row align-items-center justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: " pe-2"
  }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBLabels, {
    labelType: labelType,
    labelText: labelText,
    showCircle: true,
    subLabelType: subLabelType
  })), (versionList === null || versionList === void 0 ? void 0 : versionList.length) > 0 && /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBLabels, {
    versionValues: versionList,
    onPress: event => handleVersionSelect(event),
    value: versionValue,
    labelType: "versioning-large"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "body small"
  }, description)), /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-6"
  }, handleButton1Press && /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBButton, {
    onClick: handleButton1Press,
    extraClasses: "px-2 mx-1 header-btn-1",
    leftIconExtraClasses: "p-1",
    text: button1Text,
    size: "large",
    style: "secondary",
    state: "default",
    type: "text",
    icon: "download-blue.svg",
    iconSide: "left"
  }), handleButton2Press && /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBButton, {
    onClick: handleButton2Press,
    extraClasses: "px-2 mx-1 header-btn-2",
    leftIconExtraClasses: "p-1",
    text: button2Text,
    size: "large",
    style: "secondary",
    state: "default",
    type: "text",
    icon: "download-blue.svg",
    iconSide: "left"
  })))));
}